import React, { FC, Fragment } from 'react';
import { StaticContext } from 'react-router';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import PARTNER_ANCESTORS_QUERY from './query.graphql';
import { CrumbDivider, Crumb } from '../Breadcrumbs';
import { toTitleCase } from '../../../../../Shared/utils';

export { PARTNER_ANCESTORS_QUERY };

type PartnerSummary = {
  id: string;
  name: string;
};

type PartnerRouteParams = {
  partnerId: string;
  section?: string;
  sectionId?: string;
};

const CRUMB_TITLE_MAP: { [key: string]: string } = {
  reattribution: 'Policy Reattribution',
};

export const PartnerCrumbs: FC<
  RouteComponentProps<
    PartnerRouteParams,
    StaticContext,
    { refreshData: boolean }
  >
> = ({ match, location }) => {
  const { partnerId, section, sectionId } = match.params;
  const { data, refetch } = useQuery<{
    partner: PartnerSummary;
    partnerAncestors: Array<PartnerSummary>;
  }>(PARTNER_ANCESTORS_QUERY, {
    variables: { partnerId },
    skip: !partnerId,
  });
  const ancestors = data && data.partnerAncestors;
  const partner = data && data.partner;

  if (location.state?.refreshData) {
    refetch({
      variables: {
        id: partnerId,
      },
    });
  }

  return (
    <>
      {ancestors &&
        ancestors.map(({ id, name }) => (
          <Fragment key={id}>
            <Crumb>
              <Link to={`/admin/partners/${id}`}>{name}</Link>
            </Crumb>
            <CrumbDivider />
          </Fragment>
        ))}
      {partner && section && (
        <>
          <Crumb>
            <Link to={`/admin/partners/${partner.id}`}>{partner.name}</Link>
          </Crumb>
          <CrumbDivider />
          <Crumb>
            {sectionId ? (
              <Link to={`/admin/partners/${partner.id}/${section}`}>
                {CRUMB_TITLE_MAP[section] ?? toTitleCase(section)}
              </Link>
            ) : (
              (CRUMB_TITLE_MAP[section] ?? toTitleCase(section))
            )}
          </Crumb>
        </>
      )}
      {section === 'agencies' && sectionId === 'create' && (
        <>
          <CrumbDivider />
          <Crumb>Create New Agency</Crumb>
        </>
      )}
      {section === 'commissions' && sectionId === 'create' && (
        <>
          <CrumbDivider />
          <Crumb>Create New Commission</Crumb>
        </>
      )}
    </>
  );
};
